import styled from '@emotion/styled';

import { customPalette } from '../../../../styles/theme';

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 24px;
`;

export const SectionCard = styled.div`
  background: ${customPalette.accent.white};
  border-radius: 8px;
  padding: 24px 24px 32px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const SectionTitle = styled.h3`
  color: ${customPalette.grey[800]};
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 16px;
`;

export const ContentRow = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  width: 100%;
  margin-top: 24px;

  > div:first-of-type {
    flex-grow: 1;
    min-width: 0;
    margin-bottom: 0;
    padding-bottom: 0;
  }

  > button {
    margin-top: 0;
    align-self: center;
    margin-bottom: 0;
    padding-bottom: 0;
  }
`;

export const DateRangeContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 24px;
  align-items: center;
`;

export const ActionButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 16px;
`;

export const CreateSurveyContainer = styled(SectionCard)`
  //max-width: 600px;
  margin: 0 auto;
  width: 100%;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-top: 24px;
`;
